module.exports = __webpack_public_path__ + "img/testimonials-5.18840fb1.jpg";